/* eslint-disable @typescript-eslint/no-explicit-any */
import { type Trello } from "../types/trello"
import { getStoredCardCustomer } from "../storage"
import { qboCustomerUrl } from "../card-back-section/helpers/helpers"

// Badge callbacks run once per visible card on the board, so they read the
// denormalized copy in Trello's shared card data rather than calling the API.
// See storage.ts for how that copy is kept in step with CardCustomerLink.

/**
 * The mirrored customer, or null when it can't be trusted for this card.
 *
 * Copying a card duplicates its shared data but not the API-side link, so the
 * copy inherits the original's customer. Rejecting a copy whose stamped card id
 * doesn't match the card in context keeps the badge off it until the card back
 * reconciles. Copies written before the stamp existed carry no card id and are
 * accepted — the card back restamps them on the next open.
 */
const badgeCustomer = async (t: Trello.PowerUp.IFrame) => {
  const customer = await getStoredCardCustomer(t)
  if (!customer?.name) return null

  const contextCardId = t.getContext().card
  if (customer.cardId && contextCardId && customer.cardId !== contextCardId) return null

  return customer
}

export async function getCardBadges(
  t: Trello.PowerUp.IFrame,
  props: any
): Promise<Trello.PowerUp.CardBadge[]> {
  const customer = await badgeCustomer(t)
  if (!customer) return []

  return [
    {
      icon: props.baseUrl + props.icon.light,
      text: customer.name,
    },
  ]
}

export async function getCardDetailBadges(
  t: Trello.PowerUp.IFrame,
  props: any
): Promise<Trello.PowerUp.CardDetailBadge[]> {
  const customer = await badgeCustomer(t)
  if (!customer) return []

  return [
    {
      title: "Customer",
      icon: props.baseUrl + props.icon.light,
      text: customer.name,
      url: qboCustomerUrl(customer.id),
      target: "QuickBooks",
    },
  ]
}
